var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"klant-logos"},[_c('ul',_vm._l((_vm.logos),function(logo,index){return _c('li',{key:index},[_c('img',{attrs:{"src":logo.logo.url}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }